import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
import './styles/vant-icon.css'
import './styles/index.css'

// Vant 组件按需引入
import {
  Button,
  Cell,
  CellGroup,
  Image as VanImage,
  Icon,
  NavBar,
  Tabbar,
  TabbarItem,
  Search,
  NoticeBar,
  Grid,
  GridItem,
  Card,
  Tag,
  Loading,
  Toast,
  Dialog,
  Field,
  Form,
  Uploader,
  Picker,
  Popup,
  DatePicker,
  Swipe,
  SwipeItem,
  Skeleton,
  Empty,
  PullRefresh,
  List,
  ActionSheet,
  Badge,
  Divider,
  Stepper,
  CountDown,
  ImagePreview,
  Overlay,
  Notify,
  Switch
} from 'vant'

const app = createApp(App)

// 注册Vant组件
app.use(Button)
app.use(Cell)
app.use(CellGroup)
app.use(VanImage)
app.use(Icon)
app.use(NavBar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Search)
app.use(NoticeBar)
app.use(Grid)
app.use(GridItem)
app.use(Card)
app.use(Tag)
app.use(Loading)
app.use(Toast)
app.use(Dialog)
app.use(Field)
app.use(Form)
app.use(Uploader)
app.use(Picker)
app.use(Popup)
app.use(DatePicker)
app.use(Swipe)
app.use(SwipeItem)
app.use(Skeleton)
app.use(Empty)
app.use(PullRefresh)
app.use(List)
app.use(ActionSheet)
app.use(Badge)
app.use(Divider)
app.use(Stepper)
app.use(CountDown)
app.use(ImagePreview)
app.use(Overlay)
app.use(Notify)
app.use(Switch)

const pinia = createPinia()
app.use(pinia)
app.use(router)

app.mount('#app')
